import React, { useState } from "react";
import { toast } from "react-toastify";
import CommonModal from "../../common/commonmodal/CommonModal";
import apiServices from "../../../services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { primaryColor } from "../../../utils/comon";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../app/features/authSlice";

const UpdatePasswordModal = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const { user: authUser } = useSelector((state) => state.auth);
    const dispatch = useDispatch();



    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async () => {

        if (formData.newPassword !== formData.confirmPassword) {
            toast.error("New password and confirm password do not match.");
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                mobileNumber: authUser?.mobileNumber,
                password: formData.newPassword
            };

            const url = `/Password/putPassword/${authUser?.mobileNumber}`;
            const method = "PUT";

            const res = await apiServices({ method, url, data: payload });

            if (res?.success) {
                toast.success("Password updated successfully");
                setFormData({ newPassword: "", confirmPassword: "" });
                dispatch(logout());
                navigate("/login");

            } else {
                toast.error(res?.message || "Failed to update password.");
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error("An error occurred during submission.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <CommonModal
            isOpen={isOpen}
            onClose={onClose}
            title="Update Password"
            subTitle="Enter your old password and choose a new one."
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-xs font-bold text-gray-700 dark:text-textsecondary mb-1" htmlFor="newPassword">
                        New Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                        <input
                            className="w-full px-3 py-2 border rounded-md text-sm bg-transparent text-textprimary focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all border-gray-200 dark:border-bordercolor hover:border-gray-400 pr-10"
                            type={showNewPassword ? "text" : "password"}
                            id="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            placeholder="Enter new password"
                        />
                        <button
                            type="button"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
                        >
                            <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-700 dark:text-textsecondary mb-1" htmlFor="confirmPassword">
                        Confirm Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                        <input
                            className="w-full px-3 py-2 border rounded-md text-sm bg-transparent text-textprimary focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all border-gray-200 dark:border-bordercolor hover:border-gray-400 pr-10"
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder="Confirm new password"
                        />
                        <button
                            type="button"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
                        >
                            <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>
            </div>

            <div className="flex justify-end gap-3 mt-6 border-t dark:border-bordercolor pt-4">
                <button
                    onClick={onClose}
                    className="px-5 py-2 text-sm font-bold text-gray-600 dark:text-textsecondary bg-gray-100 dark:bg-actionitembg rounded-lg hover:bg-gray-200 dark:hover:opacity-85 transition-all"
                >
                    Cancel
                </button>
                <button
                    onClick={handleSubmit}
                    disabled={isLoading}
                    className="px-5 py-2 text-sm font-bold text-white rounded-lg transition-colors shadow-sm disabled:opacity-50 flex items-center min-w-[100px] justify-center"
                    style={{ backgroundColor: "var(--color-primaryaccent)" }}
                >
                    {isLoading ? (
                        <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                    ) : (
                        "Confirm"
                    )}
                </button>
            </div>
        </CommonModal>
    );
};

export default UpdatePasswordModal;
